import React from "react";
import _ from "lodash";
import { RadioOption } from "./RadioOption";

const GroupRadios = ({
    name,
    label = "",
    id = "",
    disabled = false,
    isHideLabel = false,
    options = [],
    required = false,
    value,
    onChange,
    className = "",
    labelClass = "",
    errors = null,
    errorName = "",
}) => {
    const msg = _.get(errors || {}, errorName || name);

    return (
        <div className={`font-urbanist ${className}`}>
            {(!!label || !isHideLabel) && (
                <label
                    htmlFor={id}
                    className={`block text-lg font-semibold mb-1 ${disabled ? "text-gray-500" : "text-white"}`}
                >
                    {label} {required && <span className="text-red-600">*</span>}
                </label>
            )}
            <fieldset className="flex gap-6 text-gray-400 text-sm font-semibold">
                <div className={`flex justify-start flex-wrap ${className}`}>
                    {options.map((opt, index) => {
                        const isChecked = value === opt.value;
                        return (
                            <RadioOption
                                key={index}
                                labelClass={labelClass}
                                name={name}
                                label={opt.label}
                                value={opt.value}
                                isChecked={isChecked}
                                onChange={onChange}
                                disabled={disabled}
                            />
                        );
                    })}
                </div>
            </fieldset>
            {/* Error message */}
            {!!msg && <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>}
        </div>
    );
};

export { GroupRadios };
